export const optionFilterProjects = [
    {name: 'Name', value: 'name', direction: 'asc'},
    { name: 'ANSR', value: 'ner', direction: 'desc' },
    { name: 'Margin', value: 'margin', direction: 'desc' }
]